define('BackorderSummary.Model',
  [
    'SCModel',
    'Utils'
  ],
  function (
    SCModelComponent,
    Utils
  ) {
    'use strict';

    var SCModel = SCModelComponent.SCModel;

    function appendParam(url, name, value) {
      var separator = url.indexOf('?') === -1 ? '?' : '&';
      return url + separator + name + '=' + encodeURIComponent(value);
    }

    function BackorderSummaryModel() {
      SCModel.call(this);

      this.urlRoot = function urlRoot() {
        return Utils.getAbsoluteUrl(
          getExtensionAssetsPath(
            'Modules/BackorderSummary/SuiteScript2/BackorderSummary.Service.ss'
          ), true
        );
      };

      this.pageUrl = function pageUrl(page) {
        return appendParam(this.urlRoot(), 'page', page);
      };

      // Export actions return a CSV/XML/TXT attachment instead of JSON.
      this.exportUrl = function exportUrl(action) {
        return appendParam(this.urlRoot(), 'action', action);
      };
    }

    BackorderSummaryModel.prototype = Object.create(SCModel.prototype);

    BackorderSummaryModel.prototype.constructor = BackorderSummaryModel;

    return BackorderSummaryModel;
  }
);
